import { Component, Input } from '@angular/core';
import { WindowService } from '@app/core/services/window.service';

@Component({
  selector: 'pcs-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['../base-menu-dropdown.scss', '../main-menu/main-menu.component.scss']
})
export class HelpMenuComponent {

  @Input() pcsDocumentationLink: string;
  @Input() mailPcsSupport: string;

  constructor(private windowService: WindowService) {
  }

  mailToPcsSupport() {
    this.windowService.changeLocation(`mailto:${this.mailPcsSupport}`);
  }

  goToPcsDocumentation() {
    this.windowService.open(this.pcsDocumentationLink);
  }
}
